import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import inserted from '@mailobj-browser/front/js/tree/inserted.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import { modifiers } from '#utilities/js/styles.js'

const names = new WeakMap()

const onCheckboxInput = object(listener, {
  type: input,
  passive,
  task: (
    element
  ) => {
    const { checked, dataset, form } = element
    const { toggleAll } = dataset
    // @TODO @NOTE: Quentin
    // Suite aux changements sur les filtres de liste, on ne disable plus les checkboxes masquées, car on
    // veut pouvoir faire une sélection en plusieurs fois, après avoir utilisé plusieurs filtres.
    // J’ai donc changé le sélecteur pour ne prendre en compte que les cases visibles, sinon ça coche également
    // les cases masquées (par un filtre ou autre).
    // À voir si on veut rétablir ce comportement quand on aura éventuellement introduit un nouveau composant de sélection multiple qui remplacera les listes dans ces cas d’utilisation. @Lucie trouve que ça permettrait de repérer plus facilement les cas où on utilise un toggleAll alors qu’on ne devrait pas.
    const visibleCheckboxes = all(`[name="${toggleAll}"]:not(.${modifiers.display.none} [name="${toggleAll}"])`, form)

    for (const checkbox of visibleCheckboxes) {
      if (checkbox.disabled === false) {
        checkbox.checked = checked
      }
    }
  }
})

const onFormInput = object(listener, {
  type: input,
  passive,
  task: (
    form,
    { target }
  ) => {
    const { name, type } = target

    if (names.get(form).has(name) && type === 'checkbox') {
      update(form, name)
    }
  }
})

export const update = (form, name) => {
  const toggleAllInput = one(`[data-toggle-all="${name}"]`, form)

  const hasOneChecked = one(`[name="${name}"]:checked:not(.${modifiers.display.none} [name="${name}"])`, form)
  const hasOneUnchecked = one(`[name="${name}"]:not(:checked):not(.${modifiers.display.none} [name="${name}"])`, form)

  toggleAllInput.indeterminate = false

  if (hasOneChecked && !hasOneUnchecked) { // only checked inputs
    toggleAllInput.checked = true
  } else if (!hasOneChecked) { // only unchecked inputs
    toggleAllInput.checked = false
  } else {
    toggleAllInput.checked = false
    toggleAllInput.indeterminate = true
  }
}

export default checkbox => {
  const { ownerDocument } = checkbox
  const { body } = ownerDocument

  queueMicrotask(async () => {
    await inserted(checkbox, body)

    const { dataset, form } = checkbox
    const { toggleAll } = dataset

    if (!names.has(form)) {
      names.set(form, new Set())
    }

    names.get(form).add(toggleAll)

    onCheckboxInput.listen(checkbox)
    onFormInput.listen(form)

    update(form, toggleAll)
  })
}
